import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import type {
  PairHoldersTableColumnId,
  PairHoldersTableContext,
} from '../atoms/reatom-pair-holders-column-id'
import type { Maker } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'
import type { DataTableModel } from '@root/shared/ui-kit'

type Props = {
  context: PairHoldersTableContext
  tableModel: DataTableModel<
    Maker.RankedMaker,
    PairHoldersTableColumnId,
    object,
    PairHoldersTableContext
  >
} & ClassNameProps

export const HoldersTable: React.FC<Props> = ({
  className,
  tableModel,
  context,
}) => {
  return (
    <AppDataTable
      className={className}
      model={tableModel}
      rowHeight={40}
      context={context}
    />
  )
}
